import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/** Standalone-site collection route: wraps <ee-help-collection>, wiring its events to the router. */
@Component({
  selector: 'app-collection',
  templateUrl: './collection.component.html',
  standalone: false,
})
export class CollectionComponent implements OnInit {
  collection = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.collection = params.get('collection') ?? '';
    });
  }

  openArticle(slug: string): void {
    this.router.navigate(['/article', slug]);
  }

  goHome(): void {
    this.router.navigate(['/']);
  }
}
